import { FC, useEffect } from 'react';
import useNavigateTo from 'hooks/useNavigateTo';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectBanner } from 'store/pages/pagesSelectors';
import { selectPreviewPageMode } from 'store/player/playerSelectors';
import IQuiz from 'models/Quiz';
// Components
import Dialog from 'components/Dialog';
import Video from 'components/Video';
import AppBar from 'components/AppBar';
import PoweredBy from 'components/PoweredBy';
// Icons
import { FiVideo } from 'react-icons/fi';

type Props = {
  onClose: () => void;
}

const VideoDialog:FC<Props> = ({
  // Props
  onClose
}) => {
  const quiz:IQuiz | null = useAppSelector(selectQuiz);
  const banner = useAppSelector(selectBanner);
  const previewPageMode = useAppSelector(selectPreviewPageMode);

  const navigateTo = useNavigateTo();

  const onEndedCallback = () => {
    onClose();
    navigateTo('pages-handler');
  }

  useEffect(() => {
    if (!banner.source && !previewPageMode) navigateTo('pages-handler');
    // eslint-disable-next-line
  }, []);

  if (!banner.source && !previewPageMode) return null;
  return (
    <Dialog
      classes="p-4"
      background={quiz?.backgroundImage ? `url('${quiz.backgroundImage}') center / cover` : '#000'}
    >
      <AppBar />
      <div className="py-4 w-full flex-1 flex flex-col items-center justify-center gap-6">
        {banner.title ? (
          <h2 className="text-xl font-bold text-primary text-center">{banner.title}</h2>
        ) : null}
        {banner.source ? (
          <div className="shadow-primary rounded-lg overflow-hidden">
            <Video
              videoUrl={banner.source}
              onEndedCallback={onEndedCallback}
            />
          </div>
        ) : (
          <div
            className="w-full rounded-lg flex flex-col items-center justify-center gap-3"
            style={{ aspectRatio: '16/9', background: 'rgba(255,255,255,0.08)', border: '2px dashed rgba(255,255,255,0.2)' }}
          >
            <FiVideo size={48} style={{ opacity: 0.3, color: 'white' }} />
            <p className="text-sm font-medium" style={{ opacity: 0.4, color: 'white' }}>Banner video</p>
          </div>
        )}
      </div>
      <PoweredBy />
    </Dialog>
  )
}

export default VideoDialog;